export const ABSTINENT = {
  id: 'abstinent',
  label: 'Astemia',
};

export const STOPPED_BEFORE_PREGNANCY = {
  id: 'stopped_before_pregnancy',
  label: 'Ha smesso prima della gravidanza',
};

export const STOPPED_WHEN_KNEW_PREGNANT = {
  id: 'stopped_when_knew_pregnant',
  label: 'Ha smesso quando ha saputo di essere in gravidanza',
};

export const STOPPED_DURING_PREGNANCY = {
  id: 'stopped_during_pregnancy',
  label: 'Ha smesso durante la gravidanza',
};

export const CONTINUED_DURING_PREGNANCY = {
  id: 'continued_during_pregnancy',
  label: 'Ha continuato ad assumere alcol durante la gravidanza',
};

export const UNKNOWN_NOT_DECLARED = {
  id: 'unknown_not_declared',
  label: 'Non noto/non dichiarato',
};
